import { render } from "./sideMenuView.vue?vue&type=template&id=2f323393&scoped=true"
import script from "./sideMenuView.vue?vue&type=script&lang=js"
export * from "./sideMenuView.vue?vue&type=script&lang=js"

import "./sideMenuView.vue?vue&type=style&index=0&id=2f323393&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f323393"]])

export default __exports__